export interface PartnerConfig {
  id: number;
  name: string;
  videoLimits: { min: number; max: number };
  guidelines: {
    showSubjectGuideline: boolean;
    customTranslationSuffix?: string;
  };
  successRoute: string;
}

// Default config for all partners not specified
export const DEFAULT_PARTNER_CONFIG: Omit<PartnerConfig, "id" | "name"> = {
  videoLimits: { min: 7, max: 120 },
  guidelines: {
    showSubjectGuideline: true,
  },
  successRoute: "/success",
};

// Partner-specific configurations
export const PARTNER_CONFIGS: Record<number, PartnerConfig> = {
  53467: {
    id: 53467,
    name: "italylunch",
    videoLimits: { min: 7, max: 15 },
    guidelines: {
      showSubjectGuideline: false,
      customTranslationSuffix: "-italylunch",
    },
    successRoute: "/success-redeem",
  },
};

// Helper to get partner config
export function getPartnerConfig(placeRef: string | null): PartnerConfig | null {
  if (!placeRef) return null;
  const partnerId = parseInt(placeRef, 10);
  return PARTNER_CONFIGS[partnerId] ?? null;
}

// Helper to get video time limits
export function getVideoTimeLimits(placeRef: string | null): {
  min: number;
  max: number;
} {
  const config = getPartnerConfig(placeRef);
  return config?.videoLimits ?? DEFAULT_PARTNER_CONFIG.videoLimits;
}

// Helper to get success route
export function getSuccessRoute(placeRef: string | null): string {
  const config = getPartnerConfig(placeRef);
  return config?.successRoute ?? DEFAULT_PARTNER_CONFIG.successRoute;
}
